import { useEffect, useState, useRef } from 'react'
import { QRCodeCanvas } from 'qrcode.react';

function QrGen() {
    const [value, setValue] = useState("tools.freelance.in.th");
    const [filename, setFilename] = useState(null);
    const [file, setFile] = useState(null);
    const [imageSrc, setImageSrc] = useState(null);
    const [imgUrl , setImgUrl] = useState('/logo192.png');
    const qrRef = useRef();

    const handleChange = (e) => {
        setValue(e.target.value);    
    }

    const onChangeFile = (e) => {
        e.preventDefault();
    
        setFile(e.target.files[0]);
        setFilename(e.target.files[0].name);
        // console.log(e.target.files[0]);
        const file = e.target.files[0];
        setImgUrl(URL.createObjectURL(file));
        // console.log(URL.createObjectURL(file));
    if (file) {
            const reader = new FileReader();

            // When the file is read, set the image source
            reader.onload = (e) => {
                setImageSrc(e.target.result);
            };

            // Read the file as a Data URL
            reader.readAsDataURL(file);
        }
      };

    // download QR code
    const handleDownload = () => {
        // Check if the ref exists
        if (qrRef.current) {
            // Find the canvas element inside the QRCodeCanvas
            const canvas = qrRef.current.querySelector("canvas");
            if (canvas) {
                // Create a temporary anchor element
                const link = document.createElement("a");

                // Set the download attribute with a filename
                link.download = "qrcode.png";

                // Convert the canvas to a Data URL and set it as the href
                link.href = canvas.toDataURL("image/png");

                // Trigger the download
                link.click();
            } else {
                console.error("Canvas element not found. Ensure QRCodeCanvas renders a canvas.");
            }
        } else {
            console.error("QR Code reference is not set. Ensure qrRef is assigned correctly.");
        }
    };
   
// console.log(`'${imgUrl}'`);
  return (
    <div className="App">
        <h1 className="flex text-center justify-center mb-4 bg-slate-300">
            QRcode Generator
        </h1>
        <div className=" items-center justify-center">
            <div className="flex flex-col sm:flex-row justify-center items-center input-group margin-bottom-sm">
                {/* <span className="input-group-addon">
                    <i className="fa fa-barcode fa-fw"></i>
                </span> */}
                <label htmlFor="qrcodeDta" className="text-sm text-slate-700 mr-1">
                    QR Data:
                </label>
                <textarea
                    name="qrcodeData"
                    // defaultValue="freelance.in.th"
                    value={value}
                    rows={4}
                    cols={40}
                    onChange={handleChange}
                    className="text-sm pl-2 ml-2 border rounded-r-md focus:outline-none ring-inset focus:ring focus:border-blue-500" 
                />
                <div ref={qrRef}
                >
                    <QRCodeCanvas
                        level='L'
                        value={value}
                        size={256}
                        imageSettings={{
                            // src: 'blob:http://localhost:3000/153e7a06-a1f8-417d-bdc9-3128033e1147',
                            src:`${imgUrl}`,
                            height: 24,
                            width: 24,
                            excavate: true,
                            }}
                        includeMargin='true'
                    />
                </div>
                <button type="button" onClick={handleDownload}>
                    Download
                </button>      
            </div>
            <label htmlFor="file">Select image file:</label>
            <input 
                type="file" 
                accept="image/*"
                id="file" 
                name="file" 
                onChange={onChangeFile} 
                
            />
            {imageSrc && (
                <img
                    src={URL.createObjectURL(file)}
                    alt="Uploaded Preview"
                    className="border mt-4 mx-auto"
                    style={{ maxWidth: "300px", maxHeight: "300px" }}
                />
            )}

        </div>
                    
    </div>
  )
}

export default QrGen